import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { ChevronIcon } from '@repo/ui/icons/ChevronIcon';
export function ExploreOtherOptionsButton(t0) {
  const $ = _c(4);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = css({
      display: "flex",
      alignItems: "center",
      gap: "1",
      minHeight: {
        md: "[32px]"
      },
      p: "[0]",
      bg: "[transparent]",
      border: "none",
      cursor: "pointer",
      textStyle: "body.small",
      fontWeight: "medium",
      color: "blues.main",
      whiteSpace: "nowrap",
      _hover: {
        textDecoration: "underline"
      }
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChevronIcon position="down" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClick) {
    t3 = <button type="button" onClick={onClick} className={t1}>Explore other card types{t2}</button>;
    $[2] = onClick;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}